import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles(() => createStyles({
  container: {},
  formContainer: {
    display: 'flex',
    gap: '16px',
    padding: '24px 0',
  },
  search: (getGridsWidth: (width: number) => number) => ({
    width: `${getGridsWidth(2)}px`,
  }),
  assignActions: (getGridsWidth: (width: number) => number) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    width: `${getGridsWidth(2)}px`,
    '& .secondary-btn': {
      fontSize: '16px',
      lineHeight: '20px',
    },
    '& .select-all': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& .btn': {
      width: '100%',
      borderRadius: '8px',
      height: '44px',
      color: whiteColor,
      fontSize: '16px',
      lineHeight: '20px',
    },
    '& .assign': {
      backgroundColor: '#BB3838',
    },
    '& .not-assign': {
      backgroundColor: '#1E8F0B',
    },
    '& .btn.disabled': {
      backgroundColor: 'rgba(30, 30, 30, 0.20) !important',
    },
  }),
  info: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '20px',
    padding: '28px 0',
    minHeight: '80px',
    '& img': {
      padding: '0 12px',
    },
  },
  statusText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '156px',
    height: '32px',
    padding: '12px 16px',
    borderRadius: '100px',
    fontSize: '12px',
    lineHeight: '16px',
  },
  statusTextNotAssigned: {
    border: '1px solid #FEE585',
    background: '#FFFBE9',
    color: '#BB3838',
  },
  statusTextAssigned: {
    backgroundColor: '#EAFEF6',
    border: '1px solid #A4F4D0',
    color: '#1E8F0B',
  },
}));
